import {FormsHelper} from "BX.Bitrix24.FormsHelper";

export class ListsElementEdit
{
	constructor(options = {name: "ListsElementEdit"})
	{
		this.name = options.name;

        this.init();
	}

    init() {
        this.checklistsAndPrescriptions();
        this.anketologDangerMap();
    }

    // list: Анкетолог "Карта опасной ситуации"
    anketologDangerMap() {
        BX.ready(function() {
            let sListCode = "LIST_ID_ANKETOLOG_DANGER_MAP";
            let iListId = BX.message(sListCode);
            let sListPath = `/services/lists/${iListId}/element/`;
            if (location.pathname.indexOf(sListPath) != -1) {
                Array.from(document.querySelectorAll(".right-cell-label")).forEach(domItem => {
                    BX.bind(BX(domItem), "click", function(e) {
                        e.preventDefault(); e.stopPropagation();
                    });
                });

                let sPath = location.pathname;
                let arMatch = sPath.match(new RegExp('^/services/lists/([0-9]*)/element/0/([0-9]*)/'));
                if (arMatch === null || arMatch.length != 3) {
                    return;
                }
                let iItemId = arMatch[2];

                BX.ajax({
                    url: "/api/v1/lists/",
                    method: "POST",
                    processData: true,
                    dataType: "json",
                    data: JSON.stringify({
                        "method": "getTaskLink",
                        "data": {
                            "iListId": iListId,
                            "iListItemId": iItemId
                        }
                    }),
                    onsuccess: function (oData) {
                        if (oData.data.taskLink) {
                            let aLink = document.createElement("a");
                            aLink.href = oData.data.taskLink;
                            aLink.textContent = "Ссылка на задачу";
                            aLink.style.color = "blue";
                            let br = document.createElement("br");
                            let domContainer = document.querySelector(".b-form__row.bx-bottom .b-form__right-cell__inner");
                            domContainer.after(br);
                            br.after(aLink);
                        } else {
                            let domDiv = document.createElement("div");
                            domDiv.textContent = "Задача не найдена";
                            domDiv.style.color = "LightCoral";

                            let br = document.createElement("br");
                            let domContainer = document.querySelector(".b-form__row.bx-bottom .b-form__right-cell__inner");
                            domContainer.after(br);
                            br.after(domDiv);
                        }
                    }
                });
            }
        });
    }

    checklistsAndPrescriptions() {
        BX.ready(function() {
            let iListId = BX.message("LIST_ID_REGISTER_CHECKLIST_PRESCRIPTION");
            let sListPath = `/bizproc/processes/${iListId}/element/`;
            if (location.pathname.indexOf(sListPath) != -1) {
                // fix bug with autoclosing user selection window
                let iUserSelectorPropId = BX.message("LIST_ID_REGISTER_CHECKLIST_PRESCRIPTION_PROP_ID_KEM_PROVODILAS_PROVERKA");
                BX.bind(BX(`tag-selector-PROPERTY_${iUserSelectorPropId}`), "click", function(e) {
                    e.preventDefault(); e.stopPropagation();
                });

                new BX.Bitrix24.FormsHelper({
                    sListIdCode: "LIST_ID_REGISTER_CHECKLIST_PRESCRIPTION",
                    arSearchSelectFieldCodes: ["SKVAZHINA"],
                    arFillSelectMethods: {
                        "SKVAZHINA": "arFillSelectWellItems"
                    }
                });
            }
        });
    }
}
